import { IUsuario } from './../../../interfaces/usuario/IUsuario';
import {
  AfterContentInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ModalExcluirUsuarioComponent } from '../../../components/modal-excluir-usuario/modal-excluir-usuario.component';
import { ModalEditarUsuarioComponent } from '../../../components/modal-editar-usuario/modal-editar-usuario.component';
import { ModalCadastrarUsuarioComponent } from '../../../components/modal-cadastrar-usuario/modal-cadastrar-usuario.component';
import { AuthenticationService, UsuarioService } from 'src/app/services';
import { ListaPaginada } from 'src/app/models';
import { debounceTime } from 'rxjs/operators';
import { IAutorizacoes } from 'src/app/interfaces/token/IAutorizacoes';
import { IToken } from 'src/app/interfaces/token/IToken';
import { ModalAtivarOuDesativarUsuarioComponent } from 'src/app/components/modal-ativar-ou-desativar-usuario/modal-ativar-ou-desativar-usuario.component';
@Component({
  selector: 'app-gestao-de-acesso',
  templateUrl: './gestao-de-acesso.component.html',
  styleUrls: ['./gestao-de-acesso.component.scss']
})
export class GestaoDeAcessoComponent
  implements OnInit, OnDestroy, AfterContentInit {
  @ViewChild(ModalCadastrarUsuarioComponent)
  modalCadastrarUsuario: ModalCadastrarUsuarioComponent;
  @ViewChild(ModalEditarUsuarioComponent)
  modalEditarUsuario: ModalEditarUsuarioComponent;

  @ViewChild(ModalExcluirUsuarioComponent)
  modalExcluirUsuario: ModalExcluirUsuarioComponent;
  @ViewChild(ModalAtivarOuDesativarUsuarioComponent)
  modalAtivarOuDesativarUsuario: ModalAtivarOuDesativarUsuarioComponent;
  subscriptions$ = new Subscription();
  token: IToken = this.authenticationService.obterToken();
  autorizacoes: IAutorizacoes;
  usuarios = new ListaPaginada<IUsuario>();
  filtraForm: FormGroup;
  // Permissoes

  gerenciarPermissoesTela() {
    this.autorizacoes = this.authenticationService.obterToken()['autorizacoes'];
  }

  constructor(
    private fb: FormBuilder,
    private usuarioService: UsuarioService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.autorizacoes = this.token.autorizacoes;
    this.filtraForm = this.fb.group({
      email: [''],
      nome: ['']
    });
    this.gerenciarPermissoesTela();
  }

  ngAfterContentInit(): void {
    this.getUsuarios();
    this.subscriptions$.add(
      this.filtraForm
        .get('nome')
        ?.valueChanges.pipe(debounceTime(1000))
        .subscribe(() => {
          this.getUsuarios(true);
        })
    );
  }

  getUsuarios(reiniciarPaginacao?: boolean) {
    if (reiniciarPaginacao) {
      this.usuarios.paginaAtual = 1;
    }
    this.subscriptions$.add(
      this.usuarioService
        .getUsuario({
          idUsuario: this.token.id,
          pesquisar: this.filtraForm.value['nome'],
          itensPorPagina: this.usuarios.itensPorPagina,
          paginaAtual: this.usuarios.paginaAtual
        })
        .subscribe({
          next: ({ data }) => {
            this.usuarios = data;
          }
        })
    );
  }

  cadastrarUsuario() {
    this.modalCadastrarUsuario.abrirModal();
  }

  editarUsuario(user: IUsuario) {
    this.modalEditarUsuario.openModal(user);
  }

  excluirUsuario(user: IUsuario) {
    this.modalExcluirUsuario.openModal(user);
  }

  ativarOuDesativarUsuario(user: IUsuario) {
    this.modalAtivarOuDesativarUsuario.openModal(user);
  }
  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
